import React from 'react';
import {AtDivider} from "taro-ui";
import styled from "styled-components";
const AtDividerWrapper = styled.div<{height:any,color:any,borderStyle?:any}>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  .at-divider__line{
    height:${({height})=> height}px !important;
    border-top: ${({height,color,borderStyle})=> `${height}px ${borderStyle} ${color}`} !important; ;
  }
`;


const TDividerWidget = (props:any) => {
  const {color,height,borderStyle} = props;
  console.log(height)
  return (
    <AtDividerWrapper height={height} color={color}  borderStyle={borderStyle}>
      <AtDivider lineColor={"transparent"}  />
    </AtDividerWrapper>
  );
};

export default TDividerWidget;
